import React, { useMemo } from 'react';
import { Flex, Tooltip } from 'antd';
import { Icon } from '@common-web/index';
import styles from './index.module.scss';

const TableActions = ({ actions = [] }) => {
  const visibleActions = useMemo(() => actions.filter((action) => !!action.show), [actions]);
  if (!visibleActions.length) return null;

  const renderActionBtn = (action, index) => {
    const { icon, onClick, color, disabled, loading, tooltip, iconSize = 18 } = action;
    const IconComponent = typeof icon === 'string' ? <Icon icon={icon} iconSize={iconSize} color={color || 'var(--ant-color-primary)'} /> : icon;

    const content = (
      <button
        className={styles.actionBtn}
        onClick={(e) => {
          e.stopPropagation();
          !disabled && !loading && onClick?.(e);
        }}
        disabled={disabled || loading}
        key={index}
      >
        {IconComponent}
      </button>
    );

    return tooltip ? (
      <Tooltip title={tooltip} key={index}>
        {content}
      </Tooltip>
    ) : (
      content
    );
  };

  return (
    <Flex gap={2} align="center" wrap="wrap">
      {visibleActions.map((action, index) => renderActionBtn(action, index))}
    </Flex>
  );
};

export default TableActions;
